module.exports = require("./../../_gen/openfl/profiler/Telemetry");